import React from 'react'
import { NavLink } from 'react-router-dom'

const LeftBar = ({ getNavSteps, finishPage, routes}) => {
  return (
    <div className="steps-screen__left-bar">
      <img src="/img/logo-white.svg" className="steps-screen__left-bar-logo" alt="Trippere logo" />
      <div className="steps-screen__left-bar-nav">
        <h2 className="steps-screen__left-bar-section">Main Info</h2>
        {getNavSteps().map((step, index) => {
          return (
            <div key={step.route}>
              {step.subtitle && <h2 className="steps-screen__left-bar-section">{step.subtitle}</h2>}
              <NavLink to={`${step.route}`} className="steps-screen__left-bar-link" activeClassName="active">
                {step.title}
                {routes[index + ''] && <span>&#10003;</span>}
              </NavLink>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default LeftBar



// WEBPACK FOOTER //
// src/components/CreatingComponent/LeftBar.js